import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-release-management',
  templateUrl: './release-management.component.html',
  styleUrls: ['./release-management.component.scss']
})
export class ReleaseManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
